import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm, Field } from 'redux-form';
import styles from './style.module.css';
import * as Routes from '../../../../../constants/routes';
import { numberWithCommas } from '../../../../../helpers';
import RenderInput from '../../../../../common/components/render-input';

export const formName = Routes.SUMMARY;

class SummaryForm extends Component {
    render() {
        return (
            <form className={styles.form}>
                <label htmlFor='loanAmount' className={styles.label}>Loan Amount</label>
                <Field
                    name='loanAmount'
                    prefix='$'
                    readOnlyValue={numberWithCommas(500000)}
                    component={RenderInput}
                />
                <label htmlFor='interestTerm' className={styles.label}>Interest term</label>
                <Field
                    name='interestTerm'
                    readOnlyValue='Personal Loans'
                    component={RenderInput}
                />
                <label htmlFor='interestRate' className={styles.label}>Interest rate</label>
                <Field
                    name='interestRate'
                    prefix='%'
                    readOnlyValue='4.95'
                    component={RenderInput}
                />
                <label htmlFor='paymentFrequency' className={styles.label}>Payment frequency</label>
                <Field
                    name='paymentFrequency'
                    readOnlyValue='Monthly'
                    component={RenderInput}
                />
                <label htmlFor='loanTerm' className={styles.label}>Loan Term</label>
                <Field
                    name='loanTerm'
                    prefix='Years'
                    readOnlyValue='5'
                    component={RenderInput}
                />
            </form>
        );
    }
}

SummaryForm = reduxForm({
    form: formName,
    destroyOnUnmount: false
})(SummaryForm);

export default connect(state => {
    return state
})(SummaryForm);
